/**
 * Admin Login page wrapper
 *
 * Wraps the shared LoginPage component with admin-specific configuration.
 */

import { useAuth } from '@startus/lib';
import { LoginPage, AuthLayout } from '@startus/ui';

interface LoginPageProps {
  onLoginSuccess: () => void;
}

export default function AdminLoginPage({ onLoginSuccess }: LoginPageProps) {
  const { login, isLoading, error, clearError } = useAuth();

  return (
    <AuthLayout maxWidth="max-w-sm">
      <LoginPage
        login={login}
        isLoading={isLoading}
        error={error}
        clearError={clearError}
        onLoginSuccess={onLoginSuccess}
        userRole="admin"
        embedded
      />
    </AuthLayout>
  );
}
